import { Outlet } from 'react-router-dom';
import { RequireOnboardingStatus } from 'domains/dashboard';

type Props = {
  children?: React.ReactNode;
};

export const OngoingSessionsGate = ({ children = <Outlet /> }: Props): JSX.Element => {
  return <RequireOnboardingStatus statuses={['ongoing_sessions']}>{children}</RequireOnboardingStatus>;
};
